import { appEventGTag } from "../event";

export const event = (location: string) => {
    appEventGTag({
        page: "exploreProviders",
        eventName: "click",
        eventLocationType: "map",
        eventLocationLabel: "map",
        mapLocation: location,
        eventLabel: "Map click"
    });
};
